import { useTheme } from "@certn/cascadia";
import {
  lightPresetStyle,
  darkPresetStyle,
  CascadiaStyle,
  Shadow,
} from "@certn/cascadia-tokens";

import { useColorScheme } from "./useColorScheme";

export function getPresetStyles(token: Shadow[]) {
  return token
    .map((token) => {
      return [
        `${token.x}px`,
        `${token.y}px`,
        `${token.blur}px`,
        `${token.spread}px`,
        `${token.color}`,
        token.inset && "inset",
      ]
        .filter(Boolean)
        .join(" ");
    })
    .join(",");
}

const lightPresetStyles = Object.keys(lightPresetStyle).reduce<
  Record<string, string>
>((prev, key) => {
  return {
    ...prev,
    [key]: getPresetStyles(lightPresetStyle[key as CascadiaStyle]),
  };
}, {});

const darkPresetStyles = Object.keys(darkPresetStyle).reduce<
  Record<string, string>
>((prev, key) => {
  return {
    ...prev,
    [key]: getPresetStyles(darkPresetStyle[key as CascadiaStyle]),
  };
}, {});

export const usePresetStyles = () => {
  const { theme = "system" } = useTheme();
  const systemTheme = useColorScheme() || "light";
  const scheme = theme === "system" ? systemTheme : theme;

  return scheme === "light" ? lightPresetStyles : darkPresetStyles;
};
